import _ from 'lodash'
import { simulateDemoProgress } from './demoData'
import { buildRetake, buildLiveRetakeCheck } from './retake'
import { createSectionArray, populateDefaultLCRPProgress } from './parse'

export function handlePreviewAction (activity, simulateData) {
  const sectionArr = createSectionArray(activity)
  const returnObj = {}
  Object.assign(returnObj, populateDefaultLCRPProgress(activity))
  activity.startActivity = false
  switch (simulateData) {
    case '0':
      break
    case '1':
      Object.assign(returnObj, buildRetakeArray(returnObj, sectionArr))
      break
    case '2':
      Object.assign(returnObj, buildRetakeArray(returnObj, sectionArr))
      Object.assign(returnObj, simulateDemoProgress(activity, 2))
      Object.assign(returnObj, populateDefaultLCRPProgress(activity))
      buildLiveRetakeCheck(returnObj)
      break
    case '3':
      Object.assign(returnObj, buildRetakeArray(returnObj, sectionArr))
      Object.assign(returnObj, buildRetake(activity, 0, 1))
      Object.assign(returnObj, simulateDemoProgress(activity, 3))
      break
    case '4':
      Object.assign(returnObj, buildRetakeArray(returnObj, sectionArr))
      Object.assign(returnObj, simulateDemoProgress(activity, 4))
      Object.assign(returnObj, populateDefaultLCRPProgress(activity))
      buildLiveRetakeCheck(returnObj)
      break
    default:
      break
  }
  return returnObj
}

function buildRetakeArray (returnObject, sectionArray) {
  _.each(sectionArray.resultsArr, (section) => {
    if (section.type === 'section') {
      returnObject.lcrp.progress.fa[`${section.sectionId}`].rd = true
    }
  })
  return returnObject
}
